import './accordion.scss';
import { gsap } from 'gsap';

class Accordion {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-accordion',
            elementAttr: 'element',
            triggerAttr: 'trigger',
            contentAttr: 'content',
            activeClassname: 'is--active',
            speed: 0.25,
            toggle: true
        };

        this.settings = Object.assign({}, settings, options);

        this.$accordion = element;
        this.$accordionElements = this.$accordion.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.elementAttr + '"]');

        this.triggerEvent = (e) => {
            const $trigger = e.target.closest('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');
            if ($trigger) {
                const $element = $trigger.closest('[' + this.settings.initAttr + '="' + this.settings.elementAttr + '"]');
                if (this.settings.toggle === true) {
                    this.toggleContent($element);
                } else {
                    this.setActiveContent($element);
                }
            }
        };
    }

    init () {
        this.$accordionElements.forEach(($element) => {
            this.toggleFocusElements($element, 'disable');
        });
        this.setEvents(true);
    }

    toggleFocusElements ($element, status) {
        const $focusableElements = $element.querySelectorAll(
            'a[href], button, textarea, input, select'
        );

        if ($focusableElements.length > 0) {
            $focusableElements.forEach((element) => {
                if (status === 'enable' || status === true || status === 1) {
                    element.setAttribute('tabindex', '0');
                } else {
                    element.setAttribute('tabindex', '-1');
                }
            });
        }
    }

    setEvents (active) {
        if (active === true) {
            this.$accordionElements.forEach((element) => {
                element.firstElementChild.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault();
                        this.toggleContent(element);
                    }
                });
            });
            this.$accordion.addEventListener('click', this.triggerEvent, false);
        } else {
            this.$accordion.removeEventListener('click', this.triggerEvent, false);
        }
    }

    toggleContent ($accordionElement) {
        if ($accordionElement.classList.contains(this.settings.activeClassname)) {
            this.closeContent($accordionElement);
        } else {
            this.openContent($accordionElement);
        }
    }

    setActiveContent ($accordionElement) {
        for (let i = 0; i < this.$accordionElements.length; i++) {
            const $currentElement = this.$accordionElements[i];

            if ($currentElement !== $accordionElement) {
                this.closeContent($currentElement);
            } else {
                this.toggleContent($accordionElement);
            }
        }
    }

    openContent ($accordionElement) {
        const $content = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        const $trigger = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');

        if ($content && $trigger) {
            $accordionElement.classList.add(this.settings.activeClassname);

            gsap.to($content, {
                height: 'auto',
                duration: this.settings.speed,
                onComplete: () => {
                    $trigger.setAttribute('aria-selected', 'true');
                    $trigger.setAttribute('aria-expanded', 'true');
                    $content.classList.add(this.settings.activeClassname);
                    $content.setAttribute('aria-hidden', 'false');
                    this.toggleFocusElements($accordionElement, 'enable');
                }
            });
        }
    }

    closeContent ($accordionElement) {
        const $content = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        const $trigger = $accordionElement.querySelector('[' + this.settings.initAttr + '="' + this.settings.triggerAttr + '"]');

        if ($content && $trigger) {
            $accordionElement.classList.remove(this.settings.activeClassname);

            gsap.to($content, {
                height: 0,
                duration: this.settings.speed,
                onComplete: () => {
                    $trigger.setAttribute('aria-selected', 'false');
                    $trigger.setAttribute('aria-expanded', 'false');
                    $content.classList.remove(this.settings.activeClassname);
                    $content.setAttribute('aria-hidden', 'true');
                    this.toggleFocusElements($accordionElement, 'disable');
                }
            });
        }
    }

    destroy () {
        this.setEvents(false);
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$accordion = $context.querySelectorAll('[data-accordion="root"]');

        for (let i = 0; i < $$accordion.length; i++) {
            const $accordion = $$accordion[i];

            const accordion = new Accordion($accordion);
            accordion.init();
        }
    }
});
